import React from "react";
import Button from "@material-ui/core/Button";
import { ReactComponent as PdfFileIcon } from "assets/pdfFileIcon.svg";
import { ReactComponent as PptFileIcon } from "assets/pptFileIcon.svg";
import DescriptionIcon from "@material-ui/icons/Description";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { FileTypes } from "./types";

type Props = {
  handleClick?: (fileType: string) => void;
  type: string;
};

const useFileFormatButtonStyles = makeThemedStyles(
  "FileFormatButton",
  (theme) => ({
    button: {
      padding: "12px 20px",
      borderRadius: "5px",
    },
    container: {
      display: "flex",
      justifyContent: "space-evenly",
      alignSelf: "stretch",
      marginTop: "0.5em",
      margin: "10px",
      gap: "10px",
    },
    pdf: {
      backgroundColor: "rgba(0, 169, 163, 0.1)",
      "&:hover": {
        background: "rgba(0, 169, 163, 0.1)",
      },
    },
    pptx: {
      backgroundColor: "rgba(246, 117, 26, 0.1)",
      "&:hover": {
        background: "rgba(246, 117, 26, 0.1)",
      },
    },
    xlxs: {
      backgroundColor: "rgba(23, 246, 26, 0.1)",
      "&:hover": {
        background: "rgba(28, 240, 26, 0.1)",
      },
    },
  })
);

const FileTypesComponents: Record<string, JSX.Element> = {
  pdf: <PdfFileIcon />,
  pptx: <PptFileIcon />,
};
const FileTypeButton = (props: Props) => {
  const { handleClick, type } = props;
  const buttonClasses = useFileFormatButtonStyles();
  const Icon = () => FileTypesComponents[type] || <DescriptionIcon />;
  const btnClasses: Record<string, string> = {
    pdf: buttonClasses.pdf,
    pptx: buttonClasses.pptx,
  };
  return (
    <Button
      className={`${buttonClasses.button} ${btnClasses[type] || ""}`}
      onClick={() => {
        if (handleClick) handleClick(type);
      }}
    >
      <Icon />
    </Button>
  );
};

export default FileTypeButton;
